import styled, { DefaultTheme } from 'styled-components';
import { Button, Typography } from 'antd';

const { Text, Title } = Typography;

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  min-height: 200px;
  gap: 24px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  color: ${(props) => getThemeValue(props, '#ff4d4f', '#ff4d4f')};
  font-size: 48px;
`;

export const ErrorTitle = styled(Title)`
  margin: 0 !important;
  color: ${(props) => getThemeValue(props, '#fff', '#1a1a1a')} !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  margin-bottom: 8px !important;
`;

export const ErrorMessage = styled(Text)`
  color: ${(props) => getThemeValue(props, '#c9d1d9', '#595959')} !important;
  font-size: 15px !important;
  line-height: 1.6 !important;
  display: block !important;
  margin-bottom: 24px !important;
`;

export const RetryButton = styled(Button)`
  background: #2D6CCA !important;
  border-color: #2D6CCA !important;
  color: white !important;
  border-radius: 8px !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  height: 40px !important;
  padding: 0 24px !important;
  transition: all 0.2s !important;

  &:hover {
    background: #2560b8 !important;
    border-color: #2560b8 !important;
    color: white !important;
    box-shadow: 0 4px 12px rgba(45, 108, 202, 0.3) !important;
  }

  &:focus {
    background: #2D6CCA !important;
    border-color: #2D6CCA !important;
    color: white !important;
  }
`;
